import React from 'react';
import {Button, Modal} from 'react-bootstrap';

const MenuItemModal = props => {
    return (
        <Modal {...props} size="xl" className='full-screen-modal' centered>
            <Modal.Body>
                <div className='w-full h-full justify-center items-center'>
                    <div className='flex w-full justify-center'>
                        <Button onClick={props.onHide} className='flex w-full md:w-1/3 text-white text-xl'>X</Button>
                    </div>
                    <div className='flex w-full justify-center'>
                        <div className='w-full md:w-1/3 bg-fms-background rounded-fms-radius-lg'>
                            <div className='flex w-full justify-end col-span-2'>
                                <div
                                    className='flex w-full min-h-fms-img-mobile-height md:min-h-fms-img-desktop-height max-h-fms-img-mobile-height md:max-h-fms-img-desktop-height rounded-t-fms-radius-base overflow-hidden'>
                                    <img
                                        src={props && props.modalProps && props.modalProps.Image ? props.modalProps.Image : require('../resources/icons/image.jpg')}
                                        alt={'icon'}
                                        className='w-full object-cover'/>
                                </div>
                            </div>
                            <div className='grid grid-cols-1 w-full rtl p-2 md:p-4 justify-center items-center'>
                                <div className='text-white space-x-2 space-y-1'>
                                    <div className='flex justify-between items-center'>
                                        <h1 className='text-base md:text-2xl font-bold'>{props?.modalProps?.Title}</h1>
                                        {props?.modalProps?.Star &&
                                        <div className='flex items-center'>
                                            <p className='text-sm md:text-lg opacity-50 ml-4 mt-6'>{props?.modalProps?.Star}</p>
                                            <div className='flex w-full h-full items-center'>
                                                <img src={require('../resources/icons/starRating.png')}
                                                     className='w-fms-icon-width h-fms-icon-height'
                                                     alt='rating-icon'/>
                                            </div>
                                        </div>}
                                    </div>

                                    <div className="border border-white opacity-50"/>

                                    <p className='text-xs md:text-sm text-fms-txt-gray max-h-fms-line-mobile-height md:max-h-fms-line-desktop-height overflow-scroll'>{props?.modalProps?.Reception}</p>

                                    <div className='flex w-full h-full justify-center items-center'
                                         style={{marginTop: '24px'}}>

                                        {props.modalProps?.Tags &&
                                        <div className='flex justify-between w-full h-full'>
                                            {props.modalProps?.Tags?.map((item) =>
                                                <p key={item.id} className='text-2xs ml-8'>{item?.text}</p>
                                            )}
                                        </div>}
                                        <div className='flex justify-between w-fit h-full -mt-4'>
                                            <h1 className='text-base md:text-2xl'>{props?.modalProps?.Price.split(' ')[0]}</h1>
                                        </div>
                                        <div className='flex items-center justify-center'>
                                            <div className='grid mr-4'>
                                                <p className='text-2xs md:text-sm'>هـزار</p>
                                                <p className='text-2xs md:text-sm -mt-4'>تومان</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<button*/}
                                    {/*    className='w-full h-fms-btn-mobile-height md:h-fms-btn-desktop-height bg-fms-btn-gray rounded-fms-radius-xl'>افزودن*/}
                                    {/*    به*/}
                                    {/*    یادداشت*/}
                                    {/*</button>*/}
                                    {/*<button*/}
                                    {/*    className='w-full h-fms-btn-mobile-height md:h-fms-btn-desktop-height bg-fms-btn-green rounded-fms-radius-xl'>افزودن*/}
                                    {/*    به*/}
                                    {/*    سبد*/}
                                    {/*    خرید*/}
                                    {/*</button>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
};

export default MenuItemModal;